// src/components/VideoComponent.js
import React, { useRef, useEffect } from 'react';

export const VideoComponent = ({ streamManager, isPublisher = false, isMobile = false }) => {
  /** @type {React.RefObject<HTMLVideoElement>} */
  const videoRef = useRef();

  useEffect(() => {
    if (streamManager && videoRef.current) {
      streamManager.addVideoElement(videoRef.current);
    }
  }, [streamManager]);

  const getDisplayName = () => {
    try {
      const connectionData = streamManager?.stream?.connection?.data;
      if (connectionData) {
        const data = JSON.parse(connectionData);
        return data.clientData || data.name || 'User';
      }
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
      console.warn('Could not parse connection data');
    }
    return 'User';
  };

  const isScreenShare = () => {
    try {
      const connectionData = streamManager?.stream?.connection?.data;
      if (connectionData) {
        const data = JSON.parse(connectionData);
        return data.mediaSource === 'screen';
      }
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
      // Ignore parsing errors
    }
    return false;
  };

  const styles = {
    container: {
      position: 'relative',
      borderRadius: isMobile ? '12px' : '8px',
      overflow: 'hidden',
      margin: isMobile ? '8px' : '10px',
      background: '#000',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    },
    publisherContainer: {
      width: isMobile ? '100%' : '300px',
      height: isMobile ? '200px' : '200px',
      border: isScreenShare() ? '3px solid #ff6b35' : '3px solid #007bff',
    },
    subscriberContainer: {
      width: isMobile ? 'calc(50% - 16px)' : '250px',
      height: isMobile ? '150px' : '150px',
      border: '2px solid #28a745',
    },
    video: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      background: '#000',
    },
    nameTag: {
      position: 'absolute',
      bottom: '8px',
      left: '8px',
      background: 'rgba(0,0,0,0.7)',
      color: 'white',
      padding: '4px 12px',
      borderRadius: '20px',
      fontSize: isMobile ? '12px' : '14px',
      fontWeight: '500',
      backdropFilter: 'blur(10px)',
    },
    screenShareBadge: {
      position: 'absolute',
      top: '8px',
      left: '8px',
      background: 'rgba(255,107,53,0.9)',
      color: 'white',
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '10px',
      fontWeight: '600',
    },
    audioMutedBadge: {
      position: 'absolute',
      top: '8px',
      right: '8px',
      background: 'rgba(220,53,69,0.9)',
      color: 'white',
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '10px',
    }
  };

  return (
    <div style={{
      ...styles.container,
      ...(isPublisher ? styles.publisherContainer : styles.subscriberContainer)
    }}>
      <video
        ref={videoRef}
        autoPlay={true}
        muted={isPublisher}
        style={styles.video}
        playsInline
      />
      
      {/* <div style={styles.nameTag}>
        {getDisplayName()} {isPublisher ? '(You)' : ''}
      </div> */}
      
      {isScreenShare() && (
        <div style={styles.screenShareBadge}>
          🖥️ Screen
        </div>
      )}
      
      {streamManager?.stream?.audioActive === false && (
        <div style={styles.audioMutedBadge}>
          🔇 Muted
        </div>
      )}
    </div>
  );
};
